import React, { useEffect, createElement } from 'react';
interface GoogleTagManagerProps {
  gtmId: string;
}
export const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({
  gtmId
}) => {
  useEffect(() => {
    // Add GTM script to head
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);
    // Add noscript iframe after body open
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.prepend(noscript);
    // Cleanup function
    return () => {
      document.head.removeChild(script);
      if (document.body.contains(noscript)) {
        document.body.removeChild(noscript);
      }
    };
  }, [gtmId]);
  return null; // This component doesn't render anything visible
};